/**
 * Deep link genérico do drawer de notificação: `?notification-drawer=<type>:<id>`. Um único param serve
 * todos os tipos — o host lê o `<type>`, acha o tipo no registry e renderiza o drawer dele com o `<id>`.
 *
 * Tipos legados (ex.: risco) também aceitam seu param antigo via `legacyDrawerParam` no contrato, pra
 * links já compartilhados não caírem num drawer vazio.
 */
export const DRAWER_QUERY_PARAM = 'notification-drawer';

export interface DrawerDeepLink {
  type: string;
  id: string;
}

/** Lê `<type>:<id>` do param genérico. `null` quando ausente/sem os dois lados. */
export const parseDrawerParam = (value: string | null): DrawerDeepLink | null => {
  if (!value) return null;
  const separator = value.indexOf(':');
  if (separator <= 0) return null;

  const type = value.slice(0, separator);
  const id = value.slice(separator + 1);
  if (!(type && id)) return null;

  return { type, id };
};

/**
 * Monta o valor do param genérico para um tipo + id. O parser quebra no PRIMEIRO `:`, então o `type` não
 * pode conter `:` (o `id` pode — vira tudo depois do primeiro). Keys do registry são controladas (sem `:`),
 * então isto é guarda de erro de dev, não de input do usuário.
 */
export const buildDrawerParam = (type: string, id: string): string => {
  if (type.includes(':')) throw new Error(`Notification type key must not contain ':' — got "${type}"`);
  return `${type}:${id}`;
};
